var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{class:[
        'count',
        {
            'good': _vm.value <= _vm.good,
            'meh': _vm.value > _vm.good && _vm.value <= _vm.bad,
            'bad': _vm.value > _vm.bad,
        }
    ]},[_vm._t("default")],2),_c('td',[_vm._v(_vm._s(_vm.itemName))])])}
var staticRenderFns = []

export { render, staticRenderFns }